import keyMirror from 'fbjs/lib/keyMirror';

// Using module.exports so that `import { KEY_NAME } from './constants/actionTypes'` works
module.exports = keyMirror({
    OPENED_IMAGE_UPLOADER: null,
    CLOSED_IMAGE_UPLOADER: null,
    IMAGE_UPLOADER_VIEW_CHANGED: null,
    GIF_SEARCH_VALUE_CHANGED: null,
    GIFS_CHANGED: null,
    GIF_SEARCH_ERROR_CHANGED: null,
    STOCK_IMAGE_SEARCH_VALUE_CHANGED: null,
    STOCK_IMAGES_CHANGED: null,
    STOCK_IMAGE_SEARCH_ERROR_CHANGED: null,
    STOCK_IMAGE_NAV_VALUE_CHANGED: null,
    IMAGE_UPLOADER_CONFIG_CHANGED: null,
    SELECTED_IMAGE: null,
    UPLOAD_IMAGE_ERROR_THROWN: null,
    STARTED_UPLOADING_IMAGE: null,
    FINISHED_UPLOADING_IMAGE: null,
});
